import { Box, Image, SystemStyleObject } from "@chakra-ui/react";

type IProps = {
  src: string;
  onClick: () => void;
  sx?: SystemStyleObject;
  type?: "login" | "signup";
  authType?: "google" | "facebook" | "apple";
};

export const SocialButton = ({ src, onClick, sx, type = "signup" }: IProps) => {
  return (
    <Box
      onClick={onClick}
      as="button"
      sx={{
        borderRadius: "0.62rem",
        height: "3.3rem",
        width: "full",
        border: "1px solid",
        borderColor: "whiteAlpha.900",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        "&:hover": {
          opacity: "0.85",
        },
        _focus: {
          outline: "2px solid",
          outlineOffset: ".3rem",
        },
        ...sx,
      }}
    >
      <Image
        src={src}
        sx={{ height: "1.4rem", objectFit: "contain", mr: ".875rem" }}
      />
      {type === "signup" ? "Join with Google" : "Log in with Google"}
    </Box>
  );
};
